import React, { useEffect, useState } from 'react';
import { QuestionOption } from '../../../types/userQuiz';
import points from './images/points.svg';
import styles from './SelectsOptions.module.scss';

const Select = ({
  option,
  answerType,
  selectedOptions,
  handleChange,
  activeGroup,
  setActiveGroup,
}: {
  option: any,
  answerType: string,
  selectedOptions: string[],
  index: number,
  activeGroup?: string | null,
  setActiveGroup: (group?: any) => void
  handleChange: (value: any) => void
}) => {
  const active = option.options?.find(
    (opt: QuestionOption) => selectedOptions.find((id :string) => opt._id === id),
  );
  function handleChangeOption(id: string, group: string) {
    if (answerType === 'uniqOption') {
      setActiveGroup();
      return handleChange([option._id]);
    }
    if (answerType === 'multiOption') {
      const selected = selectedOptions.filter(
        (s: string) => {
          const sameGroup = option.options.find((opt :QuestionOption) => opt._id === s);
          if (sameGroup?.group === group) {
            return null;
          }
          if (s === id) {
            return null;
          }
          return s;
        },
      );
      setActiveGroup();
      return handleChange([...selected, id]);
    }
    return null;
  }

  if (activeGroup && activeGroup !== option.group) {
    return null;
  }

  return (
    <div className={styles.select}>
      <button className={styles.label}
        onClick={() => setActiveGroup(activeGroup === option.group ? null : option.group)}
      >
        <p>{option.label}</p>
        {active?.text && <p className={styles.response}>{active?.text}</p>}
        {!active?.text && <img src={points} alt="points" />}
      </button>
      {activeGroup === option.group
        && <div className={styles.items}>
          {option.options.map((opt: QuestionOption) => <button
            key={opt._id}
            className={`${styles.label} ${active?._id === opt._id ? styles.active : ''}`}
            onClick={() => handleChangeOption(opt._id, option.group)}
          >
            <p>{opt.text}</p>
          </button>)}
        </div>
      }
    </div>
  );
};

const SelectOptions = ({
  options,
  selectedOptions,
  answerType,
  handleChange,
  correction,
  disabled = false,
}:{
  options: QuestionOption[],
  answerType: string,
  selectedOptions: string[],
  disabled: boolean,
  correction?:any[],
  handleChange: (value: any) => void
}) => {
  const [selects, setSelects] = useState<any[]>([]);
  const [activeGroup, setActiveGroup] = useState<string | null>();
  console.log(correction);
  useEffect(() => {
    if (options) {
      const selectList : any = [];
      options.forEach((opt :QuestionOption) => {
        if (!selectList.find((o :any) => o.group === opt.group)) {
          selectList.push({
            group: opt.group,
            label: opt.groupLabel,
            options: options.filter((o: QuestionOption) => o.group === opt.group),
          });
        }
      });
      setSelects(selectList);
    }
  }, [options]);

  return (
    <div className={`${styles.options} ${disabled ? styles.disabled : ''}`}>
      {selects.map((opt : QuestionOption, i: number) => <Select
        key={opt.group}
        index={i}
        handleChange={handleChange}
        activeGroup={activeGroup}
        setActiveGroup={setActiveGroup}
        answerType={answerType}
        selectedOptions={selectedOptions}
        option={opt}
      />)}
    </div>
  );
};

export default SelectOptions;
